// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"6027":"css/app.7076","9449":"css/admin-app.7076"}[chunkId] + ".css";
};